import { dismissExpirationNotice } from '@/api/subscription/dismiss-expiration-notice';
import { Banner } from '@/components/ui/banner';
import { useIsClient } from '@/hooks/ui/useIsClient';
import { useSettings } from '@/hooks/state/useSettings';
export const UBAlerts = () => {
  const {
    settings
  } = useSettings();
  const subscriptionData = settings?.subscriptionData;
  const isClient = useIsClient();
  const handleDismissExpirationNotice = () => {
    void dismissExpirationNotice();
  };
  if (!isClient) {
    return null;
  }

  // Expired subscription alert
  if (subscriptionData?.hasExpiredNotice) {
    return <Banner id="expired-subscription-alert" onDismiss={handleDismissExpirationNotice} type="alert" useSessionStorageForDismiss variant="float-bottom">
        <p className="fl-text-sm/base m-0 text-balance text-left font-sans text-white">
          Heads up! Your subscription has expired.
        </p>
      </Banner>;
  }
  return null;
};